import { useState, useEffect, useMemo } from 'react'

export type LayoutMode = 'mobile' | 'tablet' | 'desktop'

export interface ResponsiveLayout {
  layoutMode: LayoutMode
  isMobile: boolean
  isTablet: boolean
  isDesktop: boolean
}

export function useResponsiveLayout(): ResponsiveLayout {
  const [layoutMode, setLayoutMode] = useState<LayoutMode>(() => getLayoutMode())

  useEffect(() => {
    const mqMobile = window.matchMedia('(max-width: 767px)')
    const mqTablet = window.matchMedia('(min-width: 768px) and (max-width: 1023px)')

    const update = () => setLayoutMode(getLayoutMode())
    mqMobile.addEventListener('change', update)
    mqTablet.addEventListener('change', update)
    return () => {
      mqMobile.removeEventListener('change', update)
      mqTablet.removeEventListener('change', update)
    }
  }, [])

  return useMemo(() => ({
    layoutMode,
    isMobile: layoutMode === 'mobile',
    isTablet: layoutMode === 'tablet',
    isDesktop: layoutMode === 'desktop',
  }), [layoutMode])
}

function getLayoutMode(): LayoutMode {
  const width = window.innerWidth
  if (width < 768) return 'mobile'
  if (width < 1024) return 'tablet'
  return 'desktop'
}
